import { render, staticRenderFns } from "./Avatar_Small.vue?vue&type=template&id=40ce1036&scoped=true&"
import script from "./Avatar_Small.vue?vue&type=script&lang=js&"
export * from "./Avatar_Small.vue?vue&type=script&lang=js&"
import style0 from "./Avatar_Small.vue?vue&type=style&index=0&id=40ce1036&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40ce1036",
  null
  
)

export default component.exports